import React, {useState, useContext, useEffect} from 'react'
import {Form} from 'react-bootstrap';

import {AppContext} from '../AppContext';
import {tre} from '../trebus'

export default function SelectStop({caption, value, onChange, className}) {

    const context = useContext(AppContext);
    const [stops, setStops] = useState([]);

    const handleChange = (ev) => {
        onChange(ev.target.value);
    }

    /**
     * Cargar las paradas
     */
    const loadStops = () => {
        tre.api('GET', '/companies/' + context.user.company_id + '/stops', {
            context: context,
            success: (r) => {
                setStops(r);

                // Lanzar onChange con el primer valor
                //if (!value) onChange(r[0].id);
                //onChange(r[0].id);
            }
        });
    }

    /**
     * Context user change
     */
    useEffect(() => {

        if (context.user && context.user.company_id) loadStops();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [context.user.company_id]);

    // -----| Render |-----
    const selectControl = (
        <Form.Select
            onChange={handleChange}
            value={value}
            className={className}
            style={{
                borderRadius: '8px',
                border: '1px solid #e9ecef',
                padding: '10px 12px'
            }}
        >
            <option value="" key={0}>Seleccionar parada</option>
            {stops && stops.map(stop =>
                <option value={stop.id} key={stop.id}>{stop.name}</option>
            )}
        </Form.Select>
    );

    // If caption provided, wrap in Form.Group with label
    if (caption) {
        return (
            <Form.Group>
                <Form.Label>{caption}</Form.Label>
                {selectControl}
            </Form.Group>
        );
    }

    // Otherwise return just the select
    return selectControl;
}
	
